(function () {
  'use strict';

  /* @ngdoc object
   * @name orders.cyclic
   * @description
   *
   */
  angular
    .module('orders.cyclic', [
      'ui.router'
    ]);
}());
